<template>
  <app-page v-bind:title="list.name">
    <div slot="header-button">
      <md-button
        class="md-icon-button"
        v-on:click.native="$refs.inviteDialog.open"
      >
        <md-icon>group_add</md-icon>
      </md-button>
    </div>

    <div slot="header" class="md-toolbar-container">
      <md-input-container md-inline id="search">
        <md-icon>search</md-icon>
        <label>Ajouter un produit</label>
        <md-input v-model="searchQuery"></md-input>
        <md-button
          class="md-icon-button"
          v-show="searchQuery"
          v-on:click.native="searchQuery = ''"
        >
          <md-icon>clear</md-icon>
        </md-button>
      </md-input-container>
    </div>

    <md-progress v-if="loadingFirebase" md-indeterminate></md-progress>

    <transition-group
      name="list-complete"
      class="item-list"
      v-show="!searchQuery"
    >
      <app-item
        @image="updateImage($event, item)"
        @name="updateName($event, item)"
        v-for="item in currentListSorted"
        :key="`basket-${item.id}`"
        :item="item"
        v-on:click.native="toggleCheck(item)"
      ></app-item>
    </transition-group>

    <md-button class="md-primary" v-on:click.native="cleanupChecked"
      >cleanup</md-button
    >

    <div class="item-list">
      <app-item
        v-for="item in searchResult"
        :key="item.id"
        :item="item"
        v-on:click.native="addToList(item)"
      ></app-item>
    </div>

    <md-whiteframe v-if="showBarcodePopup" class="barcode-frame">
      <md-toolbar md-elevation="2">
        <h2 class="md-title">Scan Barcode</h2>
        <md-layout md-flex></md-layout>
        <md-button
          class="md-icon-button"
          v-on:click.native="showBarcodePopup = false"
        >
          <md-icon>clear</md-icon>
        </md-button>
      </md-toolbar>
      <app-barcode v-on:code="addByEAN"></app-barcode>
      <transition-group name="list-complete" class="item-list">
        <app-item
          v-for="item in scanned"
          :key="item.id"
          :item="item"
        ></app-item>
      </transition-group>
    </md-whiteframe>

    <md-list v-show="!searchQuery">
      <md-list-item
        v-for="section in sections"
        class="section"
        :key="section.key"
        md-expand-multiple
      >
        <span class="section-title">{{ translations[section.key] }}</span>
        <md-list-expand class="item-list">
          <app-item
            v-for="item in section.items"
            :key="item.id"
            :item="item"
            v-on:click.native="addToList(item)"
          ></app-item>
        </md-list-expand>
      </md-list-item>
    </md-list>

    <app-dial-button v-bind:items="list.items"></app-dial-button>

    <md-dialog-prompt
      md-title="Invite someone to this list"
      ref="inviteDialog"
      md-input-placeholder="e-mail"
      v-model="inviteEmail"
      v-on:close="sendInvite"
    ></md-dialog-prompt>

    <img src="../assets/Shopping_cart_with_food_clip_art_2.svg" />
  </app-page>
</template>

<script>
import Shake from "shake.js";
import DialButton from "@/components/DialButton";
import { default as ItemVM } from "@/components/Item";
import Barcode from "@/components/Barcode";
import Item, { sections, products, translations } from "@/models/Item";

import { db } from "@/helpers/firebase";

const myShakeEvent = new Shake({
  threshold: 15, // optional shake strength threshold
  timeout: 1000 // optional, determines the frequency of event generation
});

export default {
  name: "list",
  data() {
    return {
      searchQuery: "",
      showBarcodePopup: false,
      showCapturePreview: false,
      captureItem: false,
      loadingFirebase: true,
      newItem: false,
      inviteEmail: "",
      scanned: [],
      sections,
      products,
      translations,
      list: {}
    };
  },
  created() {
    this.$root.$on("startBarcode", () => {
      this.scanned = [];
      this.showBarcodePopup = true;
    });
    this.$root.$on("imageCaptured", item => {
      this.showCapturePreview = true;
      this.captureItem = item;
    });
    this.$root.$on("addToList", this.addToList);
    this.$rtdbBind("list", db.child("lists").child(this.$route.params.id))
      .then(() => {
        this.loadingFirebase = false;
      })
      .catch(error => {
        if (error.code === "PERMISSION_DENIED") {
          this.$router.push({ name: "home" });
        } else {
          console.log(error);
        }
      });
  },
  mounted() {
    window.addEventListener("shake", this.handleShakeEvent, false);
    myShakeEvent.start();
  },
  beforeDestroy() {
    myShakeEvent.stop();
    window.removeEventListener("shake", this.handleShakeEvent, false);
    this.$root.$off("addToList", this.addToList);
  },
  computed: {
    searchResult() {
      if (!this.searchQuery) {
        return [];
      }
      const result = this.products.filter(p => {
        return (
          p.name.toLowerCase().indexOf(this.searchQuery.toLowerCase()) >= 0
        );
      });
      result.push({
        id: this.searchQuery, // TODO??
        name: this.searchQuery,
        image: `https://web.getbring.com/assets/images/items/${this.searchQuery[0].toLowerCase()}.png`,
        description: ""
      });
      return result;
    },
    currentListSorted() {
      if (!this.list || !this.list.items) {
        return [];
      }
      const sorted = Object.keys(this.list.items).map(key => {
        const item = this.list.items[key];
        item.key = key;
        return item;
      });
      sorted.sort((a, b) => {
        if (a.checked === b.checked) {
          if (a.name && b.name) {
            return a.name.localeCompare(b.name);
          } else {
            return 0;
          }
        } else {
          return a.checked - b.checked;
        }
      });
      if (
        this.newItem &&
        !sorted.map(item => item.id).includes(this.newItem.id)
      ) {
        sorted.push(this.newItem);
      }
      return sorted;
    }
  },
  methods: {
    handleShakeEvent() {
      navigator.vibrate([200, 100, 200]);
      this.cleanupChecked();
    },
    addToList(item) {
      this.searchQuery = "";

      // check if in list and increment count
      if (this.list.items) {
        const key = Object.keys(this.list.items).find(key => {
          return this.list.items[key].name === item.name;
        });

        if (key) {
          const count = this.list.items[key].count || 0;
          this.$firebaseRefs.list
            .child("items")
            .child(key)
            .child("count")
            .set(count + 1);
          return;
        }
      }

      this.newItem = item;

      if (!item.image || item.image.indexOf("getbring.com") > 0) {
        Item.populateWithSearchImage(item).then(item => {
          // update firebase item
          this.$firebaseRefs.list
            .child("items")
            .push(item)
            .then(node => {
              this.newItem = false;
              this.$firebaseRefs.list
                .child("items")
                .child(node.key)
                .child("id")
                .set(node.key);
            });
        });
      } else {
        this.$firebaseRefs.list
          .child("items")
          .push(item)
          .then(node => {
            this.newItem = false;
            this.$firebaseRefs.list
              .child("items")
              .child(node.key)
              .child("id")
              .set(node.key);
          });
      }
    },
    toggleCheck(item) {
      item.checked = !item.checked;
      this.$firebaseRefs.list
        .child("items")
        .child(item.key)
        .update({ checked: item.checked });
    },
    updateName(name, item) {
      this.$firebaseRefs.list
        .child("items")
        .child(item.id)
        .update({ name, names: null });
    },
    updateImage(image, item) {
      this.$firebaseRefs.list
        .child("items")
        .child(item.id)
        .update({ image, images: null });
    },
    cleanupChecked() {
      this.currentListSorted
        .filter(i => i.checked)
        .forEach(item => {
          this.$firebaseRefs.list
            .child("items")
            .child(item.key)
            .remove();
        });
    },
    sendInvite(type) {
      if (type === "ok" && this.inviteEmail) {
        // TODO: use props for id
        db.child("lists")
          .child(this.$route.params.id)
          .child("invite_request")
          .set(this.inviteEmail);
      }
      this.inviteEmail = "";
    },
    addByEAN(code) {
      fetch(`https://world.openfoodfacts.org/api/v0/product/${code}.json`)
        .then(r => r.json())
        .then(d => {
          let item;
          if (d.status) {
            item = {
              id: code,
              name: d.product.product_name_fr,
              image: d.product.image_front_small_url,
              checked: false,
              count: 1
            };
            this.addToList(item);
          } else {
            item = {
              id: code,
              name: "Pas trouvé",
              image: "https://web.getbring.com/assets/images/items/a.png",
              checked: false,
              count: 1
            };
          }
          this.scanned.unshift(item);
        });
    }
  },
  components: {
    appDialButton: DialButton,
    appBarcode: Barcode,
    appItem: ItemVM
  }
};
</script>

<style>
#search {
  padding: 4px;
  margin: 8px 8px;
  min-height: 44px;
  border-radius: 4px;
}

#search:after,
#search .md-icon:after {
  display: none;
}

#search input,
#search label {
  font-size: 24px;
  line-height: 30px;
}

#search label {
  top: 5px;
}

#search button {
  width: 30px;
  height: 30px;
  min-width: 30px;
  margin: 0;
}

#search,
#search .md-icon,
#search input,
#search input-focused input {
  color: black;
  text-shadow: none;
  -webkit-text-fill-color: black;
  background: white;
}
.section-title {
  font-family: Pacifico;
  font-variant: normal;
}

.item-list {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  align-items: center;
  align-content: center;
}

.section .item-list {
  margin-left: 12px;
}

#barcode svg {
  margin-top: -20px;
}

.md-whiteframe.barcode-frame {
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  background: white;
  z-index: 90;
}

.list-complete-enter,
.list-complete-leave-to {
  opacity: 0;
  transform: translateY(30px);
}

.list-complete-leave-active {
  position: absolute;
}
</style>
